export const DEFAULT_COUNTRY = 'fr'
